// Open url in a new tab with noopener and noreferrer for security
export function openUrl(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}
